export function IsSpringrollShell() {
    try {
        return window.top !== window.self;
    } catch (e) {
        // ignore
    }
    return true;
}
